import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import { Dialog, DialogContent, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

// O leitor do WhatsApp exige a zona de silencio (margem clara) ao redor do
// codigo e alto contraste. No tema escuro o fundo do dialogo encostava no
// padrao e a leitura falhava, entao o QR fica sempre sobre um fundo branco
// proprio, com margem, independente do tema.
const useStyles = makeStyles(() => ({
	qrSurface: {
		backgroundColor: "#ffffff",
		padding: 16,
		borderRadius: 12,
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
	const classes = useStyles();
	const [qrCode, setQrCode] = useState("");

	useEffect(() => {
		const fetchSession = async () => {
			if (!whatsAppId) return;

			try {
				const { data } = await api.get(`/whatsapp/${whatsAppId}`, {
					params: { includeQrcode: true, _: Date.now() },
				});
				setQrCode(data.qrcode);
			} catch (err) {
				toastError(err);
			}
		};
		fetchSession();
	}, [whatsAppId]);

	useEffect(() => {
		if (!whatsAppId) return;
		const socket = openSocket();

		socket.on("whatsappSession", data => {
			if (data.action === "update" && data.session.id === whatsAppId) {
				setQrCode(data.session.qrcode);
			}

			if (
				data.action === "update" &&
				data.session.id === whatsAppId &&
				(String(data.session.status || "").toUpperCase() === "CONNECTED" ||
					data.session.qrcode === "")
			) {
				onClose();
			}
		});

		return () => {
			socket.disconnect();
		};
	}, [whatsAppId, onClose]);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="lg" scroll="paper">
			<DialogContent>
				<Paper elevation={0}>
					<Typography color="primary" gutterBottom>
						{i18n.t("qrCode.message")}
					</Typography>
					{qrCode ? (
						<div className={classes.qrSurface}>
							<QRCode
								value={qrCode}
								size={256}
								bgColor="#ffffff"
								fgColor="#000000"
								level="M"
								includeMargin
							/>
						</div>
					) : (
						<span>Waiting for QR Code</span>
					)}
				</Paper>
			</DialogContent>
		</Dialog>
	);
};

export default React.memo(QrcodeModal);
